import useSelection from "antd/es/table/hooks/useSelection";
import React, { useState } from "react";
import axios from "axios";
import { v4 } from "uuid";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import Loader from "./Loader";
import { uploadToCloudinary } from "../cloudinary";

function AddRoom() {
	const [loading, setloading] = useState(false);
	const [error, seterror] = useState();
	const navigate = useNavigate();
	const [name, setname] = useState("");
	const [maxcount, setmaxcount] = useState();
	const [type, settype] = useState("");
	const [rentpreday, setrentpreday] = useState();
	const [phonenumber, setphonenumber] = useState();
	const [description, setdescription] = useState();
	const [images, setImages] = useState([]);

	async function addroom() {
	
		try {
			setloading(true);

			const uploadResults = await Promise.all(
                images.map((image) => uploadToCloudinary(image))
            );
			const newroom = {
				name,
				maxcount,
				type,
				rentpreday,
				phonenumber,
				description,
				imageurls: uploadResults.map((res) => res.secure_url),
                imagePublicIds: uploadResults.map((res) => res.public_id),
			};
	


			const result = await axios.post(
                "https://online-hotels-booking-system-server.vercel.app/api/rooms/addroom",
                newroom
            );

			setloading(false);
			  swal.fire("Congratulations", "Room has been Added", "success").then(() => {
                navigate("/admin");
            });
		} catch (error) {
			setloading(false);
			seterror(true);
			swal.fire("Oops", "Simething went wrong", "error");
			console.log(error);
		}
		// console.log(newroom);
	}

	const updateImages = (index, newImg) => {
		const imgs = [...images];
		imgs[index] = newImg;

		setImages(imgs);
	};
	return (
		<div className="row">
			<div className="col-md-5">
				{loading && <Loader />}
				<input
					type="text"
					placeholder="room name"
					className="form-control"
					value={name}
					onChange={(e) => {
						setname(e.target.value);
					}}
				/>
				<input
					type="number"
					placeholder="rent pre day"
					className="form-control"
					value={rentpreday}
					onChange={(e) => {
						setrentpreday(e.target.value);
					}}
				/>
				<input
					type="number"
					placeholder="max count"
					className="form-control"
					value={maxcount}
					onChange={(e) => {
						setmaxcount(e.target.value);
					}}
				/>
				<input
					type="text"
					placeholder="description"
					className="form-control"
					value={description}
					onChange={(e) => {
						setdescription(e.target.value);
					}}
				/>
				<input
					type="number"
					placeholder="phone number"
					className="form-control"
					value={phonenumber}
					onChange={(e) => {
						setphonenumber(e.target.value);
					}}
				/>
			</div>

			<div className="col-md-5">
				<input
					type="text"
					placeholder="type"
					className="form-control"
					value={type}
					onChange={(e) => {
						settype(e.target.value);
					}}
				/>
				<input
					type="file"
					placeholder="image url 1"
					className="form-control"
					accept="image/*"
					onChange={(e) => {
						updateImages(0, e.target.files[0]);
					}}
				/>
				<input
					type="file"
					placeholder="image url 2"
					className="form-control"
					accept="image/*"
					onChange={(e) => {
						updateImages(1, e.target.files[0]);
					}}
				/>
				<input
					type="file"
					placeholder="image url 3"
					className="form-control"
					accept="image/*"
					onChange={(e) => {
						updateImages(2, e.target.files[0]);
					}}
				/>
				<div>
					<button className="btn btn-primary mt-2" onClick={addroom}>
						ADD ROOM
					</button>
				</div>
			</div>
		</div>
	);
}

export default AddRoom;
